import { ValidationErrors, ValidatorFn } from '@angular/forms';

import { QdKeys } from '@apps/ostk/quotas.constants';
import { Quota } from '@apps/ostk/domain/models';

export function quotaValidator (quotas: any): ValidatorFn
{
    return (): ValidationErrors | null =>
    {
        let quota: Quota;

        if (quotas[QdKeys.DISK])
        {
            quota = Quota.mapperFromObject(quotas[QdKeys.DISK]);

            if (!quota.enabled)
            {
                return { 'lackOfQuota': true };
            }
        }

        if (quotas[QdKeys.VRAM])
        {
            quota = Quota.mapperFromObject(quotas[QdKeys.VRAM]);

            if (!quota.enabled)
            {
                return { 'lackOfQuota': true };
            }
        }

        if (quotas[QdKeys.VCPU])
        {
            quota = Quota.mapperFromObject(quotas[QdKeys.VCPU]);

            if (!quota.enabled)
            {
                return { 'lackOfQuota': true };
            }
        }

        return null;
    };
}
